import { Component, OnInit, Input, SimpleChanges, OnChanges, EventEmitter, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UtilsService } from 'src/app/utils/utils.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { InfomodalComponent } from '../../shared/infomodal/infomodal.component';
import { isNullOrUndefined } from 'util';
import { UtilsSharedModule } from '../../shared/utils/utils/utils.module';
import { HEATWAVE_SOURCE } from './heatwave/heatwave-map-data/heatwave-map.constant';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-heat-index',
  templateUrl: './heat-index.component.html',
  styleUrls: ['./heat-index.component.scss']
})
export class HeatIndexComponent implements OnInit, OnChanges {

  @Input() labelStrings:any;
  @Input() blockNum: number;
  @Output() playPos = new EventEmitter<any>();
  stateUrlId: string;
  selected: any;
  modalRef : any;
  activeRadioList: boolean[] = [];
  sourceOptions:any = ['IMD','ECMWF'];
  selectedSource:any = 'IMD'
  dateIndexLength: any;
  isChecked: any = false;
  isCheckedAnga: any = false;
  enableSchoolAlert:boolean = false;
  enableAnganwadi:boolean = false;
  enableAngan:boolean = true;
  isCheckedHealthCare: boolean = false;
  enableHealthCare: boolean = false;
  // showMessage: boolean = false;
  application: any;
  applications: any;

  constructor(private router : Router ,private route: ActivatedRoute, private utils:UtilsService, private modalService: NgbModal, private utilsShared: UtilsSharedModule,private toastr: ToastrService) {
    this.stateUrlId = this.route.snapshot.paramMap.get('id');
    this.selected = this.router.url.split("/")[2]
  }

  ngOnInit() {
    // setTimeout(function(){
    //   window.location.reload();
    // },900000);
    this.reloadFunction();
    if(this.blockNum == 3) {
      this.dateIndexLength = 10
    } else {
      this.dateIndexLength = 9
    }
    for (let i = 0; i < this.dateIndexLength; ++i) {
      if (i === this.blockNum) {
        this.activeRadioList.push(true);
      } else {
        this.activeRadioList.push(false);
      }
    }
    this.subscribeEvents();
    this.application = this.router.url.split('/')[1];
    this.applications = this.router.url.split('/')[2];
  }

  subscribeEvents() {
    this.utils.getDistrictClicked().subscribe(data => {
      let locationData = data.locType;
      if(locationData != 'Block') {
        this.isChecked = false
        this.utils.schoolCheckBoxClicked.next(this.isChecked);
      }
      this.enableSchoolAlert = locationData === 'District';
      this.enableAnganwadi = locationData === 'District';
      this.enableHealthCare = locationData === 'District';
      // if(data.uuid == '78170895-ec7a-42d6-b39f-2c4eaa001944'){
      //   this.enableAngan = true;
      // }
    })
  }

  ngOnChanges(change: SimpleChanges) {
    let timeStamp = this.labelStrings[this.blockNum].groupName;
    this.utils.setTimeStamp(timeStamp)
    if (!isNullOrUndefined(change.blockNum) && Object.keys(this.labelStrings).length > 0) {
      if(change.blockNum.currentValue){
        this.buttonClicked(change.blockNum.currentValue);
      }

    } else {
      this.buttonClicked(this.blockNum);
    }
    const len = this.activeRadioList.length;
    this.activeRadioList = [];
    for (let i = 0; i < this.dateIndexLength; ++i) {
      if (i === this.blockNum) {
        this.activeRadioList.push(true);
      } else {
        this.activeRadioList.push(false);
      }
    }
  }

  validate(i){
    if(this.labelStrings[i]== undefined || this.labelStrings[i]== null){
      return ""
    }
    else{
      return this.labelStrings[i]['fullLabel'];
    }
  }

  buttonClicked(blockNumber, from?: string){
    if (from === 'HTML') {
      console.log("NOT GOING INNN");
      this.playPos.emit(blockNumber);
    }
    console.log("COMINg BLOCKNUMM",this.activeRadioList,blockNumber,this.activeRadioList[blockNumber]);
    if(this.activeRadioList[blockNumber]){
      this.utils.setIndex(this.labelStrings[blockNumber]['groupName']);
    }
  }

  infoclick(value) {
    this.modalRef = this.modalService.open(InfomodalComponent,{ backdrop: 'static', keyboard: true, windowClass: 'backgroundTransparent  infocomponent'})
    this.modalRef.componentInstance.selected = value;
  }

  reloadFunction() {
    let tsArray = this.utils.get10DaysTimeStamps();
    let curTimeStamp = new Date().getTime()
    let curInterval = tsArray['0'] - curTimeStamp;
    setTimeout(function(){
      window.location.reload();
    },curInterval);
  }

  sourceChange() {
    this.utils.setHeatWaveSource.next(HEATWAVE_SOURCE[this.selectedSource]);
  }

  toggleCheckbox(event) {
    const checkbox = event.target as HTMLInputElement;
    this.isChecked = checkbox.checked;
    if (!this.enableSchoolAlert) {
      event.preventDefault();
      // this.showMessage = true;
    } else {
      // this.showMessage = false;
      this.isChecked = (event.target as HTMLInputElement).checked;
    }
    this.utils.schoolCheckBoxClicked.next(this.isChecked);
  }

  toggleCheckboxAnganwadi(event){
    const checkbox = event.target as HTMLInputElement;
    this.isCheckedAnga = checkbox.checked;
    if (!this.enableAnganwadi) {
      event.preventDefault();
      // this.showMessage = true;
    } else {
      // this.showMessage = false;
      this.isCheckedAnga = (event.target as HTMLInputElement).checked;
    }
    this.utils.CheckBoxAngaClicked.next(this.isCheckedAnga);
  }

  toggleCheckboxHealthCare(event){
    const checkbox = event.target as HTMLInputElement;
    this.isCheckedHealthCare = checkbox.checked;
    if (!this.enableHealthCare) {
      event.preventDefault();
      // this.showMessage = true;
    } else {
      // this.showMessage = false;
      this.isCheckedHealthCare = (event.target as HTMLInputElement).checked;
    }
    this.utils.CheckBoxHealthCareClicked.next(this.isCheckedHealthCare);
  }

  showMessage() {
    if(!this.enableSchoolAlert) {
      this.toastr.error("Go to Block Level for School Alert")
    }
  }
}
